import api from '../../../helpers/api';

// export const getPendingApplicants = (body) => api.post('moderation-pool/get-pending-applicants', {...body})

export const updatePendingApplicant = body =>
  api.post('moderation-pool/moderate-applicants', { ...body });

export const getPendingApplicants = body =>
  api.post(`applicant-staging/search-applicants`, { ...body });

export const getSinglePendingApplicant = id =>
  api.get(`/applicant-staging/${id}`);

export const deleteSinglePendingApplicant = id =>
  api.delete(`applicant-staging/${id}`);

export const moderateSinglePendingApplicant = id =>
  api.post(`applicant-staging/moderate-create`, id);
export const moderateUpdateSinglePendingApplicant = id =>
  api.post(`applicant-staging/moderate-update`, id);
